module.exports = __webpack_public_path__ + "img/main_img_2.51c389af.png";